"use client"

import { useState } from "react"
import Modal from "./Modal"
import "../styles/Pricing.css"
import pricingbg from '../assets/images/pricing_bg.webp'

export default function Pricing() {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const plans = [
    {
      bhk: "3 BHK",
      price: "₹ 2,51,40,000",
      size: "2095 Sq. Ft.",
      // image: "/images/luxury-3-bhk-apartment-interior.jpg",
    },
    {
      bhk: "3 BHK + Study",
      price: "₹ 2,87,40,000",
      size: "2395 Sq. Ft.",
      // image: "/images/luxury-4-bhk-apartment-interior.jpg",
    },
    {
      bhk: "3 BHK Store + Servent Room",
      price: "₹ 3,45,00,000",
      size: "2875 Sq. Ft.",
      // image: "/images/luxury-5-bhk-apartment-interior.jpg",
    },
    {
      bhk: "4 BHK + Store",
      price: "₹ 3,71,40,000",
      size: "3095 Sq. Ft.",
      // image: "/images/luxury-3-bhk-apartment-interior.jpg",
    },    
    {
      bhk: "4 BHK+ Store + Servent Room",
      price: "₹ 4,19,40,000",
      size: "3495 Sq. Ft.",
      // image: "/images/luxury-4-bhk-apartment-interior.jpg",
    },
    {
      bhk: "4 BHK+ Store + Servent Room",
      price: "₹ 4,31,40,000",
      size: "3595 Sq. Ft.",
      // image: "/images/luxury-5-bhk-apartment-interior.jpg",
    },
  ]

  return (
    <>
      <section id="price" className="pricing" >
        <h3 className="section-label">PRICING</h3>
        <h2 className="section-title">Unlock The Luxury</h2>

        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div key={index} className="pricing-card">
              <h3>{plan.bhk}</h3>
              <p className="price1">
                Price : <span>{plan.price}</span>
              </p>
              <p className="size">Size : <strong>{plan.size}</strong></p>
              <button className="interested" onClick={() => setIsModalOpen(true)}>
                INTERESTED
              </button>
            </div>
          ))}
        </div>

 <style>
{`
.pricing {
  position: relative;
  padding: 80px 20px;
  background-color: var(--light-color);
  max-width: 100%;
  margin: 0 auto;
  overflow: hidden;
  z-index: 1;
}

.pricing::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${pricingbg});
  background-size: cover; 
  background-repeat: no-repeat;
  background-position: center 0;
  opacity: 0.7; 
  animation: move-bg 15s linear infinite alternate;
  z-index: 0;
}

.pricing > * {
  position: relative;
  z-index: 1;
}

@keyframes move-bg {
  0% {
    background-position: 0 center;
  }
  100% {
    background-position: 100% center; 
  }
}
`}
</style>

      </section>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  )
}
